import { observer } from 'mobx-react-lite'
import { AutomationLogExecutionStatusConfig } from 'entities/Integrations/ui/AutomationLogExecutionStatus'
import { type IAutomationLogExecutionStatus } from 'entities/Integrations'
import type { IWidgetProps } from 'widgets/FilterEditor/types/types'
import { WidgetStatus } from 'widgets/FilterEditor/ui/Widget/WidgetStatus'

export const WidgetAutomationLogExecutionStatus = observer((props: IWidgetProps) => {
  return (
    <WidgetStatus
      getConfigByStatus={(status) =>
        AutomationLogExecutionStatusConfig[status as IAutomationLogExecutionStatus]
      }
      {...props}
    />
  )
})
